<template>
  <Content>
    <template #body>
      <Form
        :scheme="scheme"
        :method-fetch-data="methods.fetchData"
        :method-create-data="methods.createData"
        :method-update-data="methods.updateData"
        :method-update-scheme="methods.updateScheme"
        :send-all-form="true"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Form from "@/components/Form";

import addCollectionsToScheme from "@/utils/addCollectionsToScheme";
import {
  getMuseumId as fetchData,
  postMuseum as createData,
  putMuseum as updateData,
} from "@/api/museums";
import { Museums as defaultScheme } from "@/api/schemes/museums";

const updateScheme = async (scheme) => {
  try {
    scheme = await addCollectionsToScheme(scheme);
  } catch (err) {
    console.log(err);
  }
  return scheme;
};

export default {
  components: {
    Content,
    Form,
  },
  data() {
    return {
      scheme: defaultScheme,
      methods: {
        createData,
        updateData,
        fetchData,
        updateScheme,
      },
    };
  },
};
</script>
